import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalender5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCalender5"><Path d="M15.5 3H8.5V5H7V3H3V7.5H21V3H17V5H15.5V3Z" fill="currentColor"/><Path d="M21 9H3V21H21V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalender5;
